import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.external-service', [
]);

const ExternalServiceFactory = (API_URL, $http) => {
	const ExternalService = {};

	ExternalService.Identify = (idNumber, gender) => {
		const url = `${API_URL}external-service/identify?idNumber=${idNumber}&gender=${gender}`;
		return $http.get(url).then(response => response.data);
	}

	ExternalService.CommercialOfferMessage = (idCobis, idOrigen) => {
		const url = `${API_URL}external-service/commercial-offer/message?idCobis=${idCobis}&idOrigen=${idOrigen}`;
		return $http.get(url).then(response => response.data);
	}

	ExternalService.OfficialOperator = (idCobis) => {
		const url = `${API_URL}external-service/official-operator?idCobis=${idCobis}`;
		return $http.get(url).then(response => response.data);
	}

	return ExternalService;
};

module.export = module.factory('ExternalService', ExternalServiceFactory);
